var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { filter } from 'rxjs/operators';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import { clickButtonObj, delay, showPointerOnButton, } from '../../helpers/dom-utils';
import { setCatizInternalChangeTPState_AC } from '../../store/catiz_touchpanel.actions';
import * as CatizColors from './colors';
import { transformTouchPanelDefinition } from './config/transform';
var ButtonSizes = {
    width: 100,
    height: 100,
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  background: rgba(40, 50, 80, 1);\n  background: ", ";\n  color: ", ";\n  width: 100%;\n  height: 100%;\n  grid-template-columns: 40% 60%;\n  grid-template-rows: repeat(6, 130px);\n  // grid-column-gap: 10px;\n  // grid-row-gap: 10px;\n  padding: 5px;\n"], ["\n  display: grid;\n  background: rgba(40, 50, 80, 1);\n  background: ", ";\n  color: ", ";\n  width: 100%;\n  height: 100%;\n  grid-template-columns: 40% 60%;\n  grid-template-rows: repeat(6, 130px);\n  // grid-column-gap: 10px;\n  // grid-row-gap: 10px;\n  padding: 5px;\n"])), CatizColors.blue, CatizColors.fontColor);
var bgColor = function (isIlluminate, isDisabled) {
    if (isIlluminate) {
        return '#52AAFF';
    }
    if (isDisabled) {
        return 'transparent';
    }
    return 'inherit';
};
var textColor = function (isIlluminate, isDisabled) {
    if (isIlluminate) {
        return 'black';
    }
    if (isDisabled) {
        return 'rgba(255,255,255,0.5)';
    }
    return 'inherit';
};
var Button = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  border: solid 1px black;\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  span {\n    text-align: center;\n    font-weight: bold;\n    font-size: 20px;\n  }\n  background: ", ";\n  color: ", ";\n  animation-name: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 2s;\n  @keyframes blinkbutton {\n    0% {\n      color: black;\n      background-color: #52aaff;\n    }\n    50% {\n      color: inherit;\n      background-color: inherit;\n    }\n    100% {\n      color: black;\n      background-color: #52aaff;\n    }\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  border: solid 1px black;\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  span {\n    text-align: center;\n    font-weight: bold;\n    font-size: 20px;\n  }\n  background: ",
    ";\n  color: ",
    ";\n  animation-name: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 2s;\n  @keyframes blinkbutton {\n    0% {\n      color: black;\n      background-color: #52aaff;\n    }\n    50% {\n      color: inherit;\n      background-color: inherit;\n    }\n    100% {\n      color: black;\n      background-color: #52aaff;\n    }\n  }\n"])), ButtonSizes.width, ButtonSizes.height, function (props) {
    return bgColor(props.isIlluminate || props.isBlinking, props.isDisabled);
}, function (props) {
    return textColor(props.isIlluminate || props.isBlinking, props.isDisabled);
}, function (props) { return "" + (props.isBlinking ? 'blinkbutton' : ''); });
var TextPanel = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 25px 20px;\n  grid-row: 1 / span 3;\n  margin-top: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  > div {\n    border: solid 2px black;\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    padding: 10px;\n    align-items: center;\n  }\n"], ["\n  padding: 25px 20px;\n  grid-row: 1 / span 3;\n  margin-top: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  > div {\n    border: solid 2px black;\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    padding: 10px;\n    align-items: center;\n  }\n"])));
var ExtralPanel = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  // grid-row: 1 / span 2;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(2, ", "px);\n  justify-content: center;\n  padding-top: 20px;\n  grid-gap: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  // grid-row: 1 / span 2;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(2, ", "px);\n  justify-content: center;\n  padding-top: 20px;\n  grid-gap: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n"])), ButtonSizes.width, ButtonSizes.height);
var SpecialPanel = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  // grid-row: 1 / span 2;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(2, ", "px);\n  justify-content: center;\n  padding-top: 20px;\n  grid-gap: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  // grid-row: 1 / span 2;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(2, ", "px);\n  justify-content: center;\n  padding-top: 20px;\n  grid-gap: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: relative;\n"])), ButtonSizes.width, ButtonSizes.height);
var SupportPanel = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  grid-row: 4 / span 3;\n  display: grid;\n  grid-template-columns: repeat(4, ", "px);\n  grid-template-rows: repeat(3, ", "px);\n  justify-content: center;\n  padding: 30px 10px;\n  grid-gap: 20px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  grid-row: 4 / span 3;\n  display: grid;\n  grid-template-columns: repeat(4, ", "px);\n  grid-template-rows: repeat(3, ", "px);\n  justify-content: center;\n  padding: 30px 10px;\n  grid-gap: 20px;\n  position: relative;\n"])), ButtonSizes.width, ButtonSizes.height);
var VABPanel = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  grid-row: 3 / span 3;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(3, ", "px);\n  justify-content: center;\n  padding: 30px 10px;\n  grid-gap: 20px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  grid-row: 3 / span 3;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-template-rows: repeat(3, ", "px);\n  justify-content: center;\n  padding: 30px 10px;\n  grid-gap: 20px;\n  position: relative;\n"])), ButtonSizes.width, ButtonSizes.height);
var ArrayControlPanel = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-gap: 20px;\n\n  justify-content: center;\n  // grid-auto-flow: column;\n  padding: 30px 10px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(6, ", "px);\n  grid-gap: 20px;\n\n  justify-content: center;\n  // grid-auto-flow: column;\n  padding: 30px 10px;\n  position: relative;\n"])), ButtonSizes.width);
var DebugInfo = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: absolute;\n  top: 0px;\n  right: 40px;\n  font-size: 14px;\n"], ["\n  position: absolute;\n  top: 0px;\n  right: 40px;\n  font-size: 14px;\n"])));
var Arrs;
(function (Arrs) {
    Arrs["BASIC"] = "BASIC";
    Arrs["EXTRA"] = "EXTRA";
    Arrs["KEYBOARD"] = "KEYBOARD";
    Arrs["SPECIAL"] = "SPECIAL";
    Arrs["SUPPORT"] = "SUPPORT";
    Arrs["VARIABLE"] = "VARIABLE";
})(Arrs || (Arrs = {}));
function getButtons(type, groupType, config) {
    var inputArr = config.common_uis_types[type];
    var length = +inputArr.length;
    var group = config.common_uis[groupType];
    var arr = [];
    if (group) {
        var buttons = group.buttons.map(function (button) {
            return __assign(__assign({}, button), { detail: config.common_ui[button.name] });
        });
        var maxPos_1 = 0;
        buttons.forEach(function (btn) {
            var pos = +btn.pos;
            maxPos_1 = maxPos_1 > pos ? maxPos_1 : pos;
            arr[pos] = __assign(__assign({}, btn), { pos: +btn.pos });
        });
    }
    return Array(length)
        .fill(1)
        .map(function (i, index) {
        var btn = arr[index + 1]
            ? arr[index + 1]
            : {
                name: '',
                pos: index + 1,
                detail: {
                    label: '',
                },
            };
        return btn;
    });
}
function getDefaultButtons(type, config, loadOverride) {
    var inputArr = config.common_uis_types[type];
    var length = +inputArr.length;
    var group = config.common_uis[loadOverride || inputArr.default];
    var arr = [];
    if (group) {
        var buttons = group.buttons.map(function (button) {
            return __assign(__assign({}, button), { detail: config.common_ui[button.name] });
        });
        var maxPos_2 = 0;
        buttons.forEach(function (btn) {
            var pos = +btn.pos;
            maxPos_2 = maxPos_2 > pos ? maxPos_2 : pos;
            arr[pos] = __assign(__assign({}, btn), { pos: +btn.pos });
        });
    }
    return Array(length)
        .fill(1)
        .map(function (i, index) {
        var btn = arr[index + 1]
            ? arr[index + 1]
            : {
                name: '',
                pos: index + 1,
                detail: {
                    label: '',
                },
            };
        return btn;
    });
}
function startsWithNumber(str) {
    return /^\d/.test(str);
}
function Panel(_a) {
    var type = _a.type, btnArray = _a.btnArray, PanelElement = _a.PanelElement, onButtonClick = _a.onButtonClick, buttonStatus = _a.buttonStatus;
    var clickListener = function (button) {
        var detail = button.detail;
        console.log('click listener', detail.action, button);
        onButtonClick(button);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PanelElement, null,
            btnArray.map(function (btn, index) {
                var _a, _b, _c, _d, _e, _f;
                var buttonId = startsWithNumber(btn.name)
                    ? "B_" + btn.name
                    : btn.name;
                var isDisabled = (_b = (_a = buttonStatus === null || buttonStatus === void 0 ? void 0 : buttonStatus[buttonId]) === null || _a === void 0 ? void 0 : _a.isDisabled) !== null && _b !== void 0 ? _b : false;
                return (React.createElement(Button, { id: buttonId, key: btn.name + index, onClick: function () {
                        if (!isDisabled) {
                            clickListener(__assign(__assign({}, btn), { id: buttonId }));
                        }
                    }, isIlluminate: (_d = (_c = buttonStatus === null || buttonStatus === void 0 ? void 0 : buttonStatus[buttonId]) === null || _c === void 0 ? void 0 : _c.isLit) !== null && _d !== void 0 ? _d : false, isDisabled: isDisabled, isBlinking: (_f = (_e = buttonStatus === null || buttonStatus === void 0 ? void 0 : buttonStatus[buttonId]) === null || _e === void 0 ? void 0 : _e.isBlinking) !== null && _f !== void 0 ? _f : false },
                    React.createElement(Tooltip, { title: btn.detail.description ? btn.detail.description._text : '' },
                        React.createElement("span", { className: 'button-internal' }, btn.detail.label))));
            }),
            isDebug && React.createElement(DebugInfo, null, type))));
}
var isDebug = false;
var findNode = function (touchPanelObj, btnToFind, btnPath, config) {
    var _a;
    if (btnPath === void 0) { btnPath = []; }
    var arraysToConsider = [
        Arrs.BASIC,
        Arrs.VARIABLE,
        Arrs.EXTRA,
        Arrs.SUPPORT,
        Arrs.SPECIAL,
    ];
    for (var i = 0; i < arraysToConsider.length; i++) {
        var panel = arraysToConsider[i];
        var panelButtons = touchPanelObj[panel];
        console.log('considering', panel, panelButtons);
        for (var j = 0; j < panelButtons.length; j++) {
            var button = panelButtons[j];
            if (button.name === btnToFind) {
                return {
                    found: true,
                    path: btnPath,
                };
            }
            else if (button.detail &&
                button.detail.action &&
                button.detail.action === 'requestUserInputSet') {
                console.log('going to call findNode', button);
                var detail = button.detail;
                var groupButtons = config.common_uis[detail.userData];
                var buttons = getButtons(groupButtons.type, groupButtons.name, config);
                var result = findNode(__assign(__assign({}, touchPanelObj), (_a = {}, _a[groupButtons.type] = buttons, _a)), btnToFind, __spreadArrays(btnPath, [button.name]), config);
                return result;
            }
        }
        return {
            found: false,
        };
    }
};
export default function CMSTouchPanel(props) {
    var _a;
    var _this = this;
    var onClick = props.onClick, content = props.content, actionService = props.actionService, dispatch = props.dispatch, jsonConfig = props.jsonConfig, _b = props.preloadArrays, preloadArrays = _b === void 0 ? {
        basic: '',
        variable: '',
        extra: '',
        support: '',
        special: '',
    } : _b, buttonStatus = props.buttonStatus, textPanel = props.textPanel;
    var config = useState(function () { return transformTouchPanelDefinition(jsonConfig); })[0];
    var _c = useState((_a = {},
        _a[Arrs.BASIC] = [],
        _a[Arrs.VARIABLE] = [],
        _a[Arrs.EXTRA] = [],
        _a[Arrs.SUPPORT] = [],
        _a[Arrs.SPECIAL] = [],
        _a)), uiButtons = _c[0], setUiButtons = _c[1];
    var _d = useState(moment()), date = _d[0], setDate = _d[1];
    var _e = useState(), bClickAction = _e[0], setBClickAction = _e[1];
    var ref = useRef(null);
    useEffect(function () {
        var panelState = content.touchPanelState;
        if (panelState) {
            setUiButtons(function (x) {
                var _a;
                return (_a = {},
                    _a[Arrs.BASIC] = getButtons(Arrs.BASIC, panelState.basic, config),
                    _a[Arrs.VARIABLE] = getButtons(Arrs.VARIABLE, panelState.variable, config),
                    _a[Arrs.EXTRA] = getButtons(Arrs.EXTRA, panelState.extra, config),
                    _a[Arrs.SUPPORT] = getButtons(Arrs.SUPPORT, panelState.support, config),
                    _a[Arrs.SPECIAL] = getButtons(Arrs.SPECIAL, panelState.special, config),
                    _a);
            });
        }
        else {
            setUiButtons(function (x) {
                var _a;
                return (__assign(__assign({}, x), (_a = {}, _a[Arrs.BASIC] = getDefaultButtons(Arrs.BASIC, config, preloadArrays.basic), _a[Arrs.VARIABLE] = getDefaultButtons(Arrs.VARIABLE, config, preloadArrays.variable), _a[Arrs.EXTRA] = getDefaultButtons(Arrs.EXTRA, config, preloadArrays.extra), _a[Arrs.SUPPORT] = getDefaultButtons(Arrs.SUPPORT, config, preloadArrays.support), _a[Arrs.SPECIAL] = getDefaultButtons(Arrs.SPECIAL, config, preloadArrays.special), _a)));
            });
        }
    }, [content.touchPanelState]);
    useEffect(function () {
        console.log('uiButtons changed', uiButtons, findNode(uiButtons, 'CAMERA_IR', [], config));
    }, [uiButtons]);
    useEffect(function () {
        if (actionService && content.mode === 'demo') {
            var subscription_1 = actionService
                .getActions()
                .pipe(filter(function (action) { return action.type === 'TouchPanelButtonOperation'; }))
                .subscribe(function (action) { return setBClickAction(action); });
            return function () {
                subscription_1.unsubscribe();
            };
        }
        else {
            return function () {
                console.log('Catiz-TouchPanel-No actions subscribed');
            };
        }
    }, []);
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var payload, buttonId, getButton, buttonObj, buttonPath, i, path, bObj, button;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!bClickAction) return [3, 13];
                        payload = bClickAction.payload;
                        buttonId = payload.actionPayload.TouchPanelButtonClickedId;
                        getButton = function (id) {
                            return ref.current.querySelector("#" + id);
                        };
                        if (!(buttonId && ref && ref.current)) return [3, 11];
                        buttonObj = getButton(buttonId);
                        if (!buttonObj) return [3, 2];
                        return [4, showPointerOnButton(buttonObj, dispatch)];
                    case 1:
                        _a.sent();
                        clickButtonObj(buttonObj);
                        return [3, 10];
                    case 2:
                        buttonPath = findNode(uiButtons, buttonId, [], config).path;
                        if (!buttonPath) {
                            alert("Can't find button: " + buttonId + " for current role");
                            return [2];
                        }
                        i = 0;
                        _a.label = 3;
                    case 3:
                        if (!(i < buttonPath.length)) return [3, 8];
                        path = buttonPath[i];
                        bObj = getButton(path);
                        return [4, showPointerOnButton(bObj, dispatch)];
                    case 4:
                        _a.sent();
                        return [4, clickButtonObj(bObj)];
                    case 5:
                        _a.sent();
                        return [4, delay(1000)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        i++;
                        return [3, 3];
                    case 8:
                        button = getButton(buttonId);
                        if (!button) return [3, 10];
                        return [4, showPointerOnButton(button, dispatch)];
                    case 9:
                        _a.sent();
                        clickButtonObj(button);
                        _a.label = 10;
                    case 10: return [3, 12];
                    case 11:
                        console.log('Cant click on touchpanel because buttonId:', buttonId, ' ref:', ref);
                        alert("Invalid Operation, something is wrong with the lesson definition, no buttonId provided for TouchPanelButtonOperation");
                        _a.label = 12;
                    case 12:
                        console.log(' I got action', ref, bClickAction);
                        _a.label = 13;
                    case 13: return [2];
                }
            });
        }); })();
    }, [bClickAction]);
    useEffect(function () {
        var timer = setInterval(function () {
            setDate(moment());
        }, 1000);
        return function () {
            clearInterval(timer);
        };
    }, []);
    var onPanelButtonClick = function (btn) {
        console.log('btn', btn);
        var detail = btn.detail;
        if (detail.action === 'requestUserInputSet') {
            var groupButtons = config.common_uis[detail.userData];
            dispatch(setCatizInternalChangeTPState_AC(groupButtons.type.toLowerCase(), groupButtons.name));
        }
        else {
            if (onClick) {
                onClick({ id: btn.id });
            }
        }
    };
    return (React.createElement(Container, { ref: ref },
        React.createElement(TextPanel, null, content.tutorialArea.term &&
            content.tutorialArea.showTill &&
            moment().valueOf() < content.tutorialArea.showTill ? (content.tutorialArea.term) : (React.createElement("div", null,
            React.createElement("div", null,
                "DATE: ",
                date.format('DD MMM YY')),
            React.createElement("div", null,
                "TIME: ",
                date.format('hh:mm:ss')),
            React.createElement("div", null, "Current UIS:"),
            React.createElement("div", null, textPanel === null || textPanel === void 0 ? void 0 : textPanel.currentUis),
            React.createElement("div", null, "ACTIVE ROLE:"),
            React.createElement("div", null, content.activeRole || ''),
            React.createElement("div", null, "BATTLESHORT:"),
            React.createElement("div", null, textPanel === null || textPanel === void 0 ? void 0 : textPanel.battleShort),
            React.createElement("div", null, "Radar Sesor:"),
            React.createElement("div", null, textPanel === null || textPanel === void 0 ? void 0 : textPanel.radarSensor)))),
        React.createElement(Panel, { type: "Extra", btnArray: uiButtons[Arrs.EXTRA], PanelElement: ExtralPanel, onButtonClick: onPanelButtonClick, buttonStatus: buttonStatus }),
        React.createElement(Panel, { type: "Special", btnArray: uiButtons[Arrs.SPECIAL], PanelElement: SpecialPanel, onButtonClick: onPanelButtonClick, buttonStatus: buttonStatus }),
        React.createElement(Panel, { type: "Support", btnArray: uiButtons[Arrs.SUPPORT], PanelElement: SupportPanel, onButtonClick: onPanelButtonClick, buttonStatus: buttonStatus }),
        React.createElement(Panel, { type: "Variable", btnArray: uiButtons[Arrs.VARIABLE], PanelElement: VABPanel, onButtonClick: onPanelButtonClick, buttonStatus: buttonStatus }),
        React.createElement(Panel, { type: "Basic", btnArray: uiButtons[Arrs.BASIC], PanelElement: ArrayControlPanel, onButtonClick: onPanelButtonClick, buttonStatus: buttonStatus })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map